<template>
  <div class="container-fluid">
    <h1 class="text-center fw-bold text-white title-gradient p-3 rounded">
      SKU Tax Calculation
    </h1>
    <div v-if="loader" class="text-center my-4 loader-overlay">
      <div class="fancy-loader"></div>
    </div>
    <div class="row justify-content-center align-items-start mt-4">
      <div class="col-md-6">
        <div class="card shadow-lg border-0 rounded-4">
          <div
            class="card-header text-white text-center bg-gradient-primary rounded-top-4 p-4"
          >
            <h2 class="fw-bold m-0">SKU Tax Calculation</h2>
          </div>
          <div class="card-body p-4">
            <form @submit.prevent="SKUTaxcalculations">
              <div class="form-group mb-3">
                <div v-if="skuerror" class="text-center text-danger"> {{ skuerror }} </div>
                <label class="form-label "
                  >SKU *</label
                >
                <div class="input-group">
                  <input
                    v-model="sku"
                    type="text"
                    class="form-control"
                    placeholder="Enter SKU ID"
                    required
                  />
                 
                </div>
                  <small class="text-danger" v-if="SKUlengtherror"> {{ SKUlengtherror }}  </small>
              </div>
              <div class="form-group mb-3">
                <label class="form-label fw-semibold">State</label>
                <select v-model="state" class="form-control">
                  <option value="">All States</option>
                  <option
                    v-for="st in filteredStates"
                    :key="st.id"
                    :value="st.abbreviation"
                  >
                    {{ st.name }}
                  </option>
                </select>
              </div>
              <div class="form-group mb-3">
                <label class="form-label fw-semibold">Quantity</label>
                <div class="input-group">
                  <input
                    v-model.number="quantity"
                    type="number"
                    min="1"
                    class="form-control"
                    placeholder="Enter quantity"
                    @input="quantity = $event.target.value.replace(/[^0-9]/g, '')"
                  />
                
                </div>
                  <small v-if="quantityerror" class="text-danger"> {{ quantityerror }}  </small>
              </div>
         
              <button type="submit" :disabled="loader || isSubmitted" class="btn btn-primary w-100 mt-3 fw-bold">
               <span v-if="loader">Calculating...</span>
              <span v-else>Calculate Tax</span>
             </button>

            </form>
          </div>
        </div>
      </div>
      <div v-if="result.length === 1 && state" class="col-md-6">
        <div class="card shadow rounded-4 p-3 mt-5 mt-md-0">
          <h5 class="text-center fw-bold">Tax Result</h5>
          <div class="table-responsive mt-3">
            <table class="table table-bordered text-center align-middle">
              <thead class="table-light">
                <tr>
                  <th>State</th>
                  <th>Quantity</th>
                  <th>Sale Price</th>
                  <th>Total Sale</th>
                  <th>Tax/Unit</th>
                  <th>Total Tax</th>
                  <th>Total Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ result[0].state }}</td>
                  <td>{{ formatPlainNumber(result[0].quantity) }}</td>
                  <td>${{ formatPlainNumber(result[0].sale_price) }}</td>
                  <td>${{ formatPlainNumber(result[0].total_sale_price) }}</td>
                  <td>${{ formatPlainNumber(result[0].tax_per_unit) }}</td>
                  <td>${{ formatPlainNumber(result[0].total_tax) }}</td>
                  <td>${{ formatPlainNumber(result[0].total_price) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="result.length > 1 && !state" class="row justify-content-center mt-5">
      <div class="col-md-10">
        <div class="card shadow rounded-4 p-3">
          <h5 class="text-center fw-bold">Tax Results for All States</h5>
          <div class="table-responsive">
            <table class="table table-bordered text-center align-middle">
              <thead class="table-light">
                <tr>
                  <th>State</th>
                  <th>Quantity</th>
                  <th>Sale Price</th>
                  <th>Total Sale Price</th>
                  <th>Tax Per Unit</th>
                  <th>Total Tax</th>
                  <th>Total Price</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in result" :key="index">
                  <td>{{ item.state }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>${{ item.sale_price }}</td>
                  <td>${{ item.total_sale_price }}</td>
                  <td>${{ item.tax_per_unit }}</td>
                  <td>${{ item.total_tax }}</td>
                  <td>${{ item.total_price }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SKUTaxCalculation } from "../End Points/api";

export default {
  data() {
    return {
      sku: "",
      state: "",
      quantity: 1,
      loader: false,
      skuerror: "",
      SKUlengtherror:"",
      quantityerror: "",
      result: [],
      isSubmitted: false,
    };
  },
  watch: {
  sku() {
    this.isSubmitted = false;
  },
  state() {
    this.isSubmitted = false;
  },
  quantity() {
    this.isSubmitted = false;
  }
},
  mounted() {
    this.$store.dispatch("fetchStates");
  },
  computed: {
    ...mapState(["states"]),
    filteredStates() {
      return this.states.filter((st) => st.tax_applicable);
    },
  },
  methods: {
    
    formatPlainNumber(value) {
      if (typeof value === "number") {
        const str = value.toLocaleString("fullwide", { useGrouping: false });
        return str.includes("e") ? value.toFixed(0) : str;
      } else if (typeof value === "string" && value.includes("e")) {
        return Number(value).toFixed(0);
      }
      return value;
    },
    async SKUTaxcalculations() {
      if (this.isSubmitted) return;
   let isValid = true;


   if (!this.quantity || this.quantity < 1 || this.quantity > 999999) {
  this.quantityerror = "Quantity must be between 1 and 999999";
  isValid = false;
   } else {
   this.quantityerror = "";
   }

   if (!this.sku || this.sku.length > 255) {
  this.SKUlengtherror = "SKU must not exceed 255 characters";
  isValid = false;
  } else {
  this.SKUlengtherror = "";
  }

  if (!isValid) {
  this.loader = false;
  return;
}
 this.loader = true
 this.isSubmitted = true;

      const data = {
        sku: this.sku,
        state: this.state,
        quantity: this.quantity || 1,
      };

      try {
        this.skuerror = ""
        this.quantityerror = ""
        this.SKUlengtherror = ""
        const response = await SKUTaxCalculation(data);
        this.result = Array.isArray(response.data.data)
          ? response.data.data
          : [response.data.data];

        if (response.data.status === 200) {
          this.successToast = response.data.message;
          this.$toast.success(this.successToast);
        }
      } catch (error) {
        console.error("Error from server:", error);
        this.errorMessage = "An unexpected error occurred or server side error.";
        if (error.response) {
          /*  this.skuerror = error.response.data?.message || this.errorMessage; */
          this.skuerror =  error.response.data?.message || this.errorMessage; /* " No Tax Calcluated because SKU is not Available in Products " */
          /*   this.errorToast = error.response.data?.message || this.errorMessage;
          this.$toast.error(this.errorToast); */
        } else {
          this.errorToast = this.errorMessage;
          this.$toast.error(this.errorToast);
        }
        this.result = [];
      } finally {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped>
.card-header {
  background: linear-gradient(135deg, #4f46e5, #3b82f6);
  font-size: 1.5rem;
  border-bottom: none;
}
.table th,
.table td {
  vertical-align: middle;
  text-align: center;
}
</style>
